import { Injectable } from '@angular/core';
import { ErrorHandlerService } from '@y42/error-handling';
import { AbstractFeatureGitService, getY42GitPath, Y42GitFolders } from '@y42/feature/git';
import { Y42MetadataGitModel } from '@y42/feature/json-schema';
import { GitQuery, GitService } from '@y42/git';

import { StatusAlertSettingsGitModel, StatusAlertStoreModel } from './status-alert.model';

@Injectable({ providedIn: 'root' })
export class StatusAlertGitService extends AbstractFeatureGitService<
  StatusAlertStoreModel,
  Y42GitFolders.AlertStatusAlert
> {
  constructor(
    protected readonly git: GitService,
    protected readonly gitQuery: GitQuery,
    protected readonly errorHandlerService: ErrorHandlerService,
  ) {
    super({
      gitQuery,
      git,
      name: 'Alert-Status-Alert-Git',
      basePath: getY42GitPath(Y42GitFolders.AlertStatusAlert),
      errorHandlerService,
      models: {
        metadata: {
          fileName: 'metadata.json',
          model: Y42MetadataGitModel,
        },
        settings: {
          fileName: 'settings.json',
          model: StatusAlertSettingsGitModel,
        },
      },
      hydrationDefinition: {
        1: {
          modelType: 'folder',
          childType: 'folder',
        },
      },
    });
  }
}
